/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionRead } from '../../models/session-read';

export interface CreateSessionApiV1SessionPost$Params {
}

export function createSessionApiV1SessionPost(http: HttpClient, rootUrl: string, params?: CreateSessionApiV1SessionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionRead>> {
  const rb = new RequestBuilder(rootUrl, createSessionApiV1SessionPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SessionRead>;
    })
  );
}

createSessionApiV1SessionPost.PATH = '/api/v1/session';
